module.exports = __webpack_public_path__ + "img/macbook.575b0efe.png";